module.exports = __webpack_public_path__ + "static/media/squiggle-2.48e514b8.svg";